/* eslint-disable react/prop-types */
import React from 'react';

export const Image = ({ product }) => {
  const {
    media = {},
  } = product || {};

  let imageSource = 'PRIMARY';
  const imageUrl = (media?.images?.find((img) => {
    return (img?.subType === imageSource);
  }) || {}).url;
  const POD_IMAGE_SIZE = 150;

  const RegularImage = () => {
    return (
      <img
        data-automation-id="product-image"
        src={imageUrl?.replace(/<SIZE>/g, POD_IMAGE_SIZE.toString() || '')}
        height={POD_IMAGE_SIZE}
        width="100%"
        alt="product"
      />
    );
  };

  return (
    <>
      {RegularImage()}
    </>
  );
};

Image.propTypes = {};

Image.displayName = 'Image';

Image.defaultProps = {};